module.exports = __webpack_public_path__ + "static/media/dot.7d404d8b.svg";